export default __webpack_public_path__ + "bfx/static/media/search_icon_merch.0ef9ee57.svg";